


































import Vue, { PropType } from "vue"
import SectionTitle from "~/components/guideline/util/SectionTitle.vue"
import { SkillTag } from "~/backendApis/viewModel"
import EditItemDescription from "~/components/guideline/util/EditItemDescription.vue"
import PSkillTagList from "~/components/custom/profileSkillTagSelector/PSkillTagList.vue"
import PSkillTagListItemFrame from "~/components/custom/profileSkillTagSelector/PSkillTagListItemFrame.vue"
import PSkillTagButton from "~/components/custom/profileSkillTagSelector/PSkillTagButton.vue"

export default Vue.extend({
  components: {
    SectionTitle,
    EditItemDescription,
    PSkillTagList,
    PSkillTagListItemFrame,
    PSkillTagButton,
  },
  props: {
    skillTagList: {
      type: Array as PropType<SkillTag[]>,
      required: true,
    },
    isEditable: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    editLinkForSectionTitle(): string {
      if (!this.isEditable) {
        return ""
      }

      return "/profiles/edit/skill_tag"
    },
  },
})
